export interface TrainingArea {
  id: number | null;
  name: string;
  code: string;
}

export const trainingAreaInit = {
  id: null,
  name: "",
  code: "",
};
